import Footer from "../components/elements/Footer";
import { redirectToLogin } from "../helper/common.helper";
import c from "./errors.module.scss";

function Unauthorized() {
	return (
		<div className={c.main_error_page}>
			<div className={c.main_error}>
				<div className={c.main_image}>
					<img src="/images/404.svg" alt="" className={c.image} />
				</div>
				<div className={c.main_desc}>
					<h2 className={c.title}>Accesso non consentito per il tuo ruolo</h2>
					<p className={c.desc}>
						Il tuo utente non ha i permessi per accedere a questa applicazione.
					</p>
				</div>

				<div className={c.main_cta}>
					<button type="button" onClick={redirectToLogin} className="button fill primary small">
						Torna al login ›
					</button>
				</div>
			</div>

			<Footer />
		</div>
	);
}

export default Unauthorized;
